import { LegalEntity } from '@Common/types/bo/users/users';
import { SharesStatus } from '@Common/types/instruments/instrument';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const countryEntityChoices = makeChoicesCommon<LegalEntity>()({
  sal: 'resources.bo_common.instruments/countries_status.entities.sal',
  sfa: 'resources.bo_common.instruments/countries_status.entities.sfa',
  sda: 'resources.bo_common.instruments/countries_status.entities.sda',
});

export const sharesStatusChoices = makeChoicesCommon<SharesStatus>()({
  disabled: 'resources.bo_common.instruments/countries_status.shares_status.disabled',
  sell_only: 'resources.bo_common.instruments/countries_status.shares_status.sell_only',
  suspended: 'resources.bo_common.instruments/countries_status.shares_status.suspended',
  tradable: 'resources.bo_common.instruments/countries_status.shares_status.tradable',
});
